<template>
  <main class="pt-12 lg:pt-32">
    <h1 class="my-16 text-center text-5xl leading-tight text-white md:text-7xl md:leading-tight">Privacy</h1>
    <Container>
      <section class="grid gap-10 text-white lg:grid-cols-2">
        <div
          v-for="(policy, index) in policies"
          :key="index">
          <h2 class="mb-2 text-2xl font-bold leading-[1.2]">
            {{ policy.title }}
          </h2>
          <p>{{ policy.description }}</p>
          <NuxtLink
            :href="policy.link"
            class="block font-bold underline">
            {{ policy.label }}
          </NuxtLink>
        </div>
      </section>
    </Container>
  </main>
</template>

<script setup lang="ts">
  import policies from '@/assets/data/privacy-general.json'

  const TITLE = 'Privacy & Data Protection | Outfit7 – Trusted by Families Worldwide'
  const DESCRIPTION =
    'We care about your privacy. Read Outfit7’s global privacy policy to learn how we protect players of all ages around the world.'

  const route = useRoute()
  const { cdnUrl } = useRuntimeConfig().public

  useHead({
    title: TITLE,
    link: [
      {
        rel: 'canonical',
        href: `https://outfit7.com${route.path}`
      }
    ],
    meta: [
      { hid: 'description', name: 'description', content: DESCRIPTION },
      { hid: 'og:title', property: 'og:title', content: TITLE },
      { hid: 'og:description', property: 'og:description', content: DESCRIPTION },
      {
        hid: 'og:image',
        property: 'og:image',
        content: `${cdnUrl}/assets/2_our_story/2_0_this_is_us/this_is_us_below_header.jpg`
      },
      { hid: 'twitter:title', name: 'twitter:title', content: TITLE },
      { hid: 'twitter:description', name: 'twitter:description', content: DESCRIPTION },
      {
        hid: 'twitter:image',
        name: 'twitter:image',
        content: `${cdnUrl}/assets/2_our_story/2_0_this_is_us/this_is_us_below_header.jpg`
      }
    ]
  })
</script>
